<div class="modal1Main">
  <div class="modalHeader">
    <span class="title">Scoring Summary</span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div class="body">
    <!-- <ng-container *ngIf="weekMetrix.length>0">
      <div class="loader" style="width: 50%;"></div>
      <div class="loader" style="width: 50%;" > <mat-spinner color="accent" diameter="50"></mat-spinner></div>
     
    </ng-container> -->
    <ng-container *ngIf="weekMetrix.length>0">
      <div *ngIf="weekMetrix.length>0" id="league-info" class="heading">
        <div class="lg-name">{{ lgmData.lg_name }}
          <div class="team-name">
            <span>{{ lgmData.team_name }}</span>
          </div>
        </div>
         
        <div class="statsofuser">
          <div class="points">
            <p class="svalue">{{lgmData?.team_total|number:'1.0-2'}}</p>
            <p class="slabel">Points</p>
          </div>
          <div class="place"> 
            <p class="svalue" *ngIf="!isLoading">{{prettyPrint(lgmData?._tour_id != 0?lgmData?.tour_rank:lgmData?.team_rank)}} </p>
            <p class="slabel">Place</p>
          </div>
            <div class="advofuser">
              <p class="svalue amount">
                ${{lgmData?.payout | number:'1.2-2' | Price}}
              </p>
              <p class="slabel">Winning</p>
            </div>
        </div>
      </div>
     
      <div class="bottom-part">
            <table class="table statTable">
              <thead class="thead">
                <tr>
                  <th class="label"></th>
                  <th class="label playername">Week</th>
                  <th class="label" *ngFor="let week of this.lgmData.weekSlider;">{{ week.label }}</th>
                  <th class="label">Total</th>
                </tr>
              </thead>
              <tbody class="table">
                <tr *ngFor="let row of weekMetrix; let i = index">
                  <td class="label col posname" [ngStyle]="{'color':row.colorcode?row.colorcode:''}">{{ row.rp }}</td>
                  <td class="col playername">
                    <div class="headshot"[ngStyle]="{'background-image':'url(\''+playerURL+row.pic+'\')'}"></div>
                    <div class="name">{{row.name}}</div>
                 </td>
                  <td class="col fpts" [ngClass]="{'showbold':col.use || row.name == 'Total'}" *ngFor="let col of row?.weeks; let i = index">
                    {{ ((col.fpts!= null) ? col.fpts : col) | number:'1.2-2' }}
                  </td>
                  <td class="col total">{{ row.total | number:'1.2-2' }}</td>
                </tr>
              </tbody>
            </table> 
          <div *ngIf="WeekList && WeekList == ''" class="text-center minHeight150">No record found</div>
      </div>
    </ng-container>
  </div>
</div>